// @ts-nocheck

import { useContext } from 'react';

import { GRHomeContext, type GRHomeContextProps } from '../contexts/GRHomeContext';

const useGRHomeContext = () => useContext<GRHomeContextProps>(GRHomeContext);

export default useGRHomeContext;
